import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"
import { useEffect } from "react"
import {
  Navbar,
  HeroSection,
  ProductOverview,
  // Features,
  QualitySustainability,
  WhatWeDo,
  ScotchBonnet,
  PottingMix,
  ContactForm,
  Footer,
  ThankYou,
  Services,
  JoinOurTeam,
  ProposedProjects,
  UpcomingProjects,
  MissionVision,
  PeopleEmpowering,
  ScotchBonnetLearnMore,
  PottingMixLearnMore,
  Export,
  Investment,
  WhatsAppButton

} from "./components"

function AppContent() {
  const location = useLocation()
  const hideNavbar =
    location.pathname === "/careers" ||
    location.pathname === "/learn-more" ||
    location.pathname === "/learn-more-potting-mix" ||
    location.pathname === "/export" || 
    location.pathname === "/investments"

  // Scroll to anchor on hash change
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "")
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: "smooth" })
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }, [location.pathname, location.hash])

  return (
    <main className="min-h-screen">
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <ProductOverview />
              <ScotchBonnet />
              <PottingMix />
              <Services />
              {/* <Features /> */}
              <MissionVision />
              <WhatWeDo />
              <QualitySustainability />
              <PeopleEmpowering />
              {/* <ComingSoon /> */}
              <UpcomingProjects />
              <ProposedProjects />
              <ContactForm />
            </>
          }
        />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/careers" element={<JoinOurTeam />} />
        <Route path="/learn-more" element={<ScotchBonnetLearnMore />} />
        <Route path="/learn-more-potting-mix" element={<PottingMixLearnMore />} />
        <Route path="/export" element={<Export />} />
        <Route path="/investments" element={<Investment />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </main>
  )
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}
